import { styled } from 'styled-components';

import { visuallyHiddenCss } from '#/components/VisuallyHidden/VisuallyHidden';
import { colors, linkStyles, spacing } from '#/theme/theme';

export const listingRichTextTruncatedMaxHeightVar = '--local-rich-text-height';

export const ListingRichTextTruncatedHolder = styled.div`
  &:has(+ label input:not(:checked)) {
    max-height: var(${listingRichTextTruncatedMaxHeightVar});
    text-overflow: ellipsis;
    overflow: hidden;

    position: relative;

    &::before {
      content: '';
      position: absolute;
      left: 0;
      height: 40px;
      width: 100%;
      bottom: 0;
      background: linear-gradient(to top, ${colors.white}, transparent);
      pointer-events: none;
      z-index: 1;
    }
  }
`;

export const ListingRichTextTruncatedToggleLabel = styled.label`
  display: block;
  margin-top: ${spacing[16]};
  cursor: pointer;
  padding: ${spacing[8]} ${spacing[16]};
  ${linkStyles};

  .show-more,
  .show-less {
    display: flex;
    align-items: center;
    gap: ${spacing[8]};
  }

  &:has(input:checked) {
    .show-more {
      display: none;
    }
  }

  &:not(:has(input:checked)) {
    .show-less {
      display: none;
    }
  }

  input {
    ${visuallyHiddenCss}
  }
`;
